exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._24AWINHReYjNBf{align-items:center;background-color:#dfe1e6;background-position:50%;background-repeat:no-repeat;background-size:cover;border:0;border-radius:100%;box-sizing:border-box;color:#172b4d;display:inline-flex;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Noto Sans,Ubuntu,Droid Sans,Helvetica Neue,sans-serif;font-size:12px;font-weight:700;justify-content:center;line-height:28px;opacity:1;height:28px;width:28px;overflow:hidden;white-space:nowrap}._24AWINHReYjNBf._3cImyX2kTlgxxi{background-color:#f4f5f7;color:#6b778c}._24AWINHReYjNBf._1BOFNoyaspEBu6{background-color:#dfe1e6;border:1px solid #dfe1e6}._24AWINHReYjNBf._1BOFNoyaspEBu6._3cImyX2kTlgxxi{background-color:#ebecf0}._3pnKfi0FcRvKSs ._24AWINHReYjNBf{margin-left:4px;margin-top:4px;float:right}.gane1tbb2Vu40u ._24AWINHReYjNBf{align-self:flex-start;flex:0 0 auto}", ""]);

// exports
exports.locals = {
	"avatar": "_24AWINHReYjNBf",
	"deactivated": "_3cImyX2kTlgxxi",
	"lightBackground": "_1BOFNoyaspEBu6",
	"cardFront": "_3pnKfi0FcRvKSs",
	"detailHeader": "gane1tbb2Vu40u"
};